import { PrimaryButton } from "../PrimaryButton.tsx";
import { IconButton } from "../IconButton.tsx";
import { ComponentType, ReactElement, ReactNode } from "react";

export function ScreenTitleBlock({
  title,
  ctaLabel,
  ctaOnClick,
  ctaIcon,
  loading,
  breadCrumbs,
  subTitle,
  action,
}: {
  title: string;
  ctaLabel?: string;
  ctaOnClick?: () => void;
  ctaIcon?: ComponentType<{ className?: string }>;
  loading?: boolean;
  breadCrumbs?: ReactElement;
  subTitle?: string | ReactNode;
  action?: ReactNode;
}) {
  function hasCta(): boolean {
    return !!(ctaLabel && ctaOnClick);
  }
  return (
    <>
      <div className={"flex flex-col space-y-3"}>
        {breadCrumbs ?? null}
        <div className={"flex items-center justify-between gap-3"}>
          <h1 className={"font-bold text-2xl"}>{title}</h1>
          {action ??
            (hasCta() ? (
              ctaIcon && ctaOnClick ? (
                <>
                  <div className={"hidden md:block"}>
                    <PrimaryButton
                      loading={loading}
                      onClick={ctaOnClick}
                      label={ctaLabel ?? ""}
                    />
                  </div>
                  <div className={"md:hidden"}>
                    <IconButton
                      label={ctaLabel ?? ""}
                      icon={ctaIcon}
                      onClick={ctaOnClick}
                    />
                  </div>
                </>
              ) : (
                <PrimaryButton
                  loading={loading}
                  onClick={ctaOnClick}
                  label={ctaLabel ?? ""}
                />
              )
            ) : null)}
        </div>
        {subTitle ? (
          typeof subTitle === "string" ? (
            <p>{subTitle}</p>
          ) : (
            subTitle
          )
        ) : null}
      </div>
    </>
  );
}
